"use client";

import { ArrowRightAlt } from "@ellaandil/ui";
import { clsx } from "@trydig/ui";
import { type ComponentProps, forwardRef, useId } from "react";
import { useTranslations } from "@/i18n/client";

export interface ActionInputProps extends ComponentProps<"input"> {
	error?: string | boolean;
	success?: string | boolean;
}

export const ActionInput = forwardRef<HTMLInputElement, ActionInputProps>(
	({ className, id: initialId, ...props }, ref) => {
		const t = useTranslations();
		const internalId = useId();
		const id = initialId ?? internalId;

		return (
			<label
				className={clsx(
					"block py-1 transition-all border-b border-neutral-black-30 hover:border-white",
					className,
				)}
				htmlFor={id}
			>
				<div className="flex items-center h-8 gap-2">
					<input
						ref={ref}
						id={id}
						className="text-text-sand-text-3 text-sm bg-transparent outline-none flex-1 placeholder:text-text-sand-text-3 placeholder:text-sm"
						{...props}
					/>
					<button type="submit" className="shrink-0" aria-label={t("Submit")}>
						<ArrowRightAlt className="size-6" />
					</button>
				</div>
			</label>
		);
	},
);

ActionInput.displayName = "ActionInput";
